
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buyoffers",
      function () {
        return require("private-next-pages/buyoffers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buyoffers"])
      });
    }
  